/* =====================================================================
   NayHogar · librería de experiencias (nhx) · base
   Cada sección "Experiencia del producto" (sections/nh-experiencia.liquid) trae:
     - data-nhx-tipo   : el tipo ya normalizado en Liquid (antes-despues, medidas, enciendelo, ...)
     - data-nhx-dato   : el metacampo tal cual (nayhogar.experiencia / puntos / pasos) + data-nhx-indice
   y la página trae una sola vez los datos REALES del producto ([data-nhx-producto], snippets/nhx-datos.liquid).
   Cada tipo vive en assets/exp-<tipo>.js y se registra con NHX.registrar(tipo, fn). fn(root, dato, ctx) dibuja la
   experiencia y devuelve false si le faltan datos: entonces sale el modo de reserva (fotos reales + puntos de la
   descripción). Nada inventado: todo sale de los datos del producto.
   ===================================================================== */
(function () {
  if (window.NHX) return;
  const tipos = {};
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fino = window.matchMedia('(pointer: fine)').matches;
  const NHX = window.NHX = { registrar(tipo, fn) { tipos[tipo] = fn; }, tipos, reduce, fino };

  /* ---------------- utilidades ---------------- */
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // número desde "25", "25,5", "25.5 cm", "1.500 ml" (punto de miles colombiano) o 25
  function num(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'number') return isFinite(v) ? v : null;
    let s = String(v).trim().toLowerCase().replace(/[^\d.,-]/g, '');
    if (!s) return null;
    if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(',', '.');
    const n = parseFloat(s);
    return isFinite(n) ? n : null;
  }
  // 25.5 -> "25,5" ; 1500 -> "1.500"
  function fmt(n, dec) {
    if (n == null || !isFinite(n)) return '';
    const d = dec == null ? (Math.abs(n - Math.round(n)) < 0.05 ? 0 : 1) : dec;
    const t = (Math.round(n * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d).split('.');
    t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return d ? t[0] + ',' + t[1] : t[0];
  }
  const clamp = (x, a, b) => Math.min(b, Math.max(a, x));
  const lerp = (a, b, k) => a + (b - a) * k;
  function el(tag, cls, html, attrs) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    if (attrs) Object.keys(attrs).forEach(k => { if (attrs[k] != null) e.setAttribute(k, attrs[k]); });
    return e;
  }
  // arrastre con mouse, dedo o lápiz (pointer events con captura)
  function drag(target, h) {
    let activo = false, id = null;
    target.addEventListener('pointerdown', e => {
      if (e.button != null && e.button > 0) return;
      activo = true; id = e.pointerId;
      try { target.setPointerCapture(id); } catch (x) {}
      if (h.start) h.start(e);
      if (h.move) h.move(e);
    });
    target.addEventListener('pointermove', e => { if (activo && e.pointerId === id && h.move) h.move(e); else if (!activo && h.hover) h.hover(e); });
    const fin = e => { if (!activo || e.pointerId !== id) return; activo = false; if (h.end) h.end(e); };
    target.addEventListener('pointerup', fin);
    target.addEventListener('pointercancel', fin);
    return { get activo() { return activo; } };
  }
  // posición del puntero relativa a un elemento, de 0 a 1
  function rel(e, box) {
    const b = box.getBoundingClientRect();
    return { x: clamp((e.clientX - b.left) / b.width, 0, 1), y: clamp((e.clientY - b.top) / b.height, 0, 1), b };
  }
  function alVer(elm, cb, umbral) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    const ob = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { ob.disconnect(); cb(); } }), { threshold: umbral == null ? 0.35 : umbral });
    ob.observe(elm);
  }
  function precargar(src) { return new Promise(r => { if (!src) return r(null); const i = new Image(); i.onload = () => r(i); i.onerror = () => r(null); i.decoding = 'async'; i.src = src; }); }
  function animar(dur, cb, fin) {
    if (reduce) { cb(1); if (fin) fin(); return () => {}; }
    const t0 = performance.now(); let parar = false;
    const paso = t => { if (parar) return; const k = clamp((t - t0) / dur, 0, 1); cb(k); if (k < 1) requestAnimationFrame(paso); else if (fin) fin(); };
    requestAnimationFrame(paso);
    return () => { parar = true; };
  }
  const suave = k => k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;

  // colores por nombre (mismo vocabulario que snippets/color-hex.liquid)
  const COLORES = {
    negro: '#1F1F1F', negra: '#1F1F1F', blanco: '#F4F2EE', blanca: '#F4F2EE', gris: '#9A9A9A', 'gris claro': '#C9C9C9', 'gris oscuro': '#555555',
    plateado: '#C0C4C8', plata: '#C0C4C8', dorado: '#C9A55A', 'dorado claro': '#DCC17E', 'palo rosa': '#D7A9A0', rosado: '#EBA5B5', rosa: '#EBA5B5',
    fucsia: '#D63A87', rojo: '#C8332F', vinotinto: '#6E1F2B', vino: '#6E1F2B', granate: '#7A2430', naranja: '#E8833A', amarillo: '#EBC844',
    mostaza: '#C99A2E', verde: '#5E9A62', 'verde menta': '#A8D8C0', menta: '#A8D8C0', pistacho: '#B8CC8A', 'verde pistacho': '#B8CC8A', oliva: '#7A7A45',
    azul: '#3D6FB6', 'azul claro': '#9CC3E6', 'azul bebe': '#BCD7EE', 'azul rey': '#2F4FB0', 'azul oscuro': '#22325A', 'azul petroleo': '#1F4E5A',
    turquesa: '#3CB8B2', aguamarina: '#7FD1C3', morado: '#7D5BA6', lila: '#CDBFE3', lavanda: '#CDBFE3', cafe: '#6B4A35', 'café': '#6B4A35', marron: '#6B4A35',
    'marrón': '#6B4A35', caramelo: '#B47A45', beige: '#E2D3BC', crema: '#EFE5D2', arena: '#D8C7A8', salmon: '#F0A58C', 'salmón': '#F0A58C', madera: '#A0703F',
    nogal: '#6E4B32', transparente: '#E9EEF0', multicolor: 'conic-gradient(#E8833A,#EBC844,#5E9A62,#3D6FB6,#7D5BA6,#E8833A)', variado: 'conic-gradient(#E8833A,#EBC844,#5E9A62,#3D6FB6,#7D5BA6,#E8833A)'
  };
  function colorHex(nombre) {
    if (!nombre) return null;
    const n = String(nombre).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
    if (COLORES[n]) return COLORES[n];
    const conAcento = String(nombre).toLowerCase().trim();
    if (COLORES[conAcento]) return COLORES[conAcento];
    // "Negro / Queen" -> "negro"; "Hojas Dorado" -> busca palabra conocida
    const partes = n.split(/[\/,·-]/)[0].trim();
    if (COLORES[partes]) return COLORES[partes];
    const palabras = n.split(/\s+/);
    for (let i = palabras.length; i > 0; i--) for (let j = 0; j + i <= palabras.length; j++) { const w = palabras.slice(j, j + i).join(' '); if (COLORES[w]) return COLORES[w]; }
    return null;
  }

  /* ---------------- datos del producto ---------------- */
  let P = null;
  function producto() {
    if (P) return P;
    const s = document.querySelector('[data-nhx-producto]');
    try { P = s ? JSON.parse(s.textContent) : null; } catch (e) { P = null; }
    if (!P) P = { fotos: [], variantes: [], opciones: [] };
    P.fotos = (P.fotos || []).filter(f => f && f.src);
    P.fotos.sort((a, b) => (a.pos || 0) - (b.pos || 0));
    P.variantes = P.variantes || [];
    P.opciones = P.opciones || [];
    P.medidas = parseJSON(P.medidas);
    P.incluye = parseJSON(P.incluye);
    return P;
  }
  function parseJSON(v) {
    if (typeof v === 'string') { const t = v.trim(); if (t[0] === '{' || t[0] === '[') { try { return JSON.parse(t); } catch (e) { return v; } } }
    return v;
  }
  const absoluta = s => /^(https?:)?\/\//.test(s) || /^(file|data|blob):/.test(s);

  // Resuelve una foto: 3 (posición en la galería, empieza en 1), "variante:Negro", "ambiente", URL o nombre de archivo
  // subido en Contenido > Archivos. Devuelve { src, med, alt } o null.
  function foto(ref) {
    const p = producto();
    if (ref == null || ref === '') return null;
    if (typeof ref === 'object' && ref.src) return ref;
    if (typeof ref === 'number' || /^\d+$/.test(String(ref).trim())) {
      const n = parseInt(ref, 10);
      return p.fotos.find(f => f.pos === n) || null;
    }
    const s = String(ref).trim();
    const m = s.match(/^variante\s*:\s*(.+)$/i);
    if (m) return fotoVariante(m[1]);
    if (/^ambiente$/i.test(s)) return fotoAmbiente();
    if (absoluta(s)) return { src: s, med: s, alt: '' };
    if (p.archivos) { const u = p.archivos + encodeURIComponent(s).replace(/%2F/g, '/'); return { src: u, med: u, alt: '' }; }
    return null;
  }
  function fotoVariante(valor) {
    const p = producto();
    const v = String(valor).toLowerCase().trim();
    const vv = p.variantes.find(x => x.foto && (x.opciones || []).some(o => String(o).toLowerCase().trim() === v));
    if (vv) { const f = p.fotos.find(x => String(x.id) === String(vv.foto)); if (f) return f; }
    return null;
  }
  // foto de ambiente: la que tenga texto alternativo que empiece por "Ambiente" (guía de fotos); si no, ninguna
  function fotoAmbiente() {
    const p = producto();
    return p.fotos.find(f => /^\s*ambiente/i.test(f.alt || '')) || null;
  }
  function fotosEstudio() { const p = producto(); return p.fotos.filter(f => !/^\s*ambiente/i.test(f.alt || '')); }

  // medidas normalizadas en cm (acepta "medidas": {"alto": "25 cm", "ancho": 6.5, "unidad": "mm"})
  function medidas(m) {
    m = parseJSON(m);
    if (!m || typeof m !== 'object') return null;
    const f = (m.unidad && /mm/i.test(m.unidad)) ? 0.1 : (m.unidad && /^m$/i.test(m.unidad)) ? 100 : 1;
    const o = {};
    ['alto', 'ancho', 'fondo', 'diametro', 'largo', 'peso'].forEach(k => { const v = m[k] != null ? m[k] : (m[k + '_cm'] != null ? m[k + '_cm'] : (k === 'diametro' ? m['diámetro'] : null)); const n = num(v); if (n != null) o[k] = k === 'peso' ? n : n * f; });
    if (Array.isArray(m.extra)) o.extra = m.extra;
    if (o.largo != null && o.ancho == null) o.ancho = o.largo;
    if (o.diametro != null) { if (o.ancho == null) o.ancho = o.diametro; if (o.fondo == null) o.fondo = o.diametro; }
    if (m.capacidad_ml != null) o.ml = num(m.capacidad_ml);
    else if (m.ml != null) o.ml = num(m.ml);
    else if (m.capacidad_l != null) o.ml = num(m.capacidad_l) * 1000;
    else if (m.capacidad != null) { const c = String(m.capacidad); const n = num(c); if (n != null) o.ml = /l\b|litro/i.test(c) && !/ml/i.test(c) ? n * 1000 : n; }
    o.peso_txt = m.peso;
    return Object.keys(o).some(k => typeof o[k] === 'number') ? o : null;
  }

  // opción de color y valores reales de las variantes
  function opcionColor() {
    const p = producto();
    const i = p.opciones.findIndex(o => /colou?r|tono|diseño|diseno|acabado/i.test(o));
    return i;
  }
  function seleccionar(indice, valor) {
    document.dispatchEvent(new CustomEvent('nt:select', { detail: { index: indice, value: valor } }));
  }
  function alCambiarVariante(cb) { document.addEventListener('nt:variant', e => { if (e.detail && e.detail.variant) cb(e.detail.variant, e.detail); }); }

  // puntos de la descripción (<li>) para el modo de reserva
  function puntosDescripcion() {
    const p = producto();
    if (!p.descripcion) return [];
    const d = document.createElement('div'); d.innerHTML = p.descripcion;
    return Array.from(d.querySelectorAll('li')).map(li => li.textContent.trim()).filter(Boolean).slice(0, 8);
  }

  function pista(texto, icono) {
    const ic = { mano: '<path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-1.5a1.5 1.5 0 0 1 3 0V11m0-1a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1-6 6h-.6a6 6 0 0 1-4.9-2.6L4 15.3a1.5 1.5 0 0 1 2.4-1.8L9 15"/>',
      flechas: '<path d="M8 7l-5 5 5 5M16 7l5 5-5 5M3 12h18"/>', toca: '<circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="8" opacity=".45"/>' }[icono || 'mano'];
    return '<span class="nhx-hint" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + ic + '</svg>' + esc(texto) + '</span>';
  }
  function imgTag(f, cls, attrs) {
    if (!f) return '';
    const a = attrs || {};
    return '<img class="' + (cls || '') + '" src="' + esc(f.src) + '" alt="' + esc(a.alt != null ? a.alt : (f.alt || producto().titulo || '')) + '"' +
      (a.eager ? '' : ' loading="lazy"') + ' decoding="async" draggable="false"' + (f.w ? ' width="' + f.w + '" height="' + Math.round(f.w / (f.ar || 1)) + '"' : '') + '>';
  }

  /* ---------------- modo de reserva ----------------
     Cuando un producto aún no tiene datos de experiencia (o le faltan): "Míralo de cerca" con sus fotos reales, una
     lupa que sigue el dedo y los puntos de su descripción. Si ni eso hay, la sección se oculta. */
  function reserva(root, sec, fuente) {
    const p = producto();
    const pts = puntosDescripcion();
    if (fuente === 'puntos') {
      if (!pts.length) return false;
      root.innerHTML = '<ol class="nhx-rpts">' + pts.map((t, i) => '<li data-reveal><b>' + String(i + 1).padStart(2, '0') + '</b><span>' + esc(t) + '</span></li>').join('') + '</ol>';
      root.querySelectorAll('[data-reveal]').forEach((x, i) => setTimeout(() => x.classList.add('in'), 80 * i));
      return true;
    }
    const fs = fotosEstudio().slice(0, 6);
    if (!fs.length) return false;
    root.innerHTML =
      '<div class="nhx-res">' +
        '<div class="nhx-res__stage nhx-stage" data-lupa>' + imgTag(fs[0], 'nhx-res__img nhx-prod') + '<span class="nhx-res__lens" aria-hidden="true"></span>' + pista(fino ? 'Pasa el mouse para ver de cerca' : 'Toca y desliza para ver de cerca', 'toca') + '</div>' +
        '<div class="nhx-res__side">' +
          (fs.length > 1 ? '<div class="nhx-res__thumbs" role="tablist" aria-label="Fotos">' + fs.map((f, i) => '<button type="button" role="tab" aria-selected="' + (i === 0) + '" data-i="' + i + '">' + imgTag({ src: f.med || f.src }, 'nhx-prod', { alt: 'Foto ' + (i + 1) }) + '</button>').join('') + '</div>' : '') +
          (pts.length ? '<ul class="nhx-res__pts">' + pts.slice(0, 5).map(t => '<li>' + esc(t) + '</li>').join('') + '</ul>' : '') +
        '</div>' +
      '</div>';
    const stage = root.querySelector('[data-lupa]'), img = stage.querySelector('img'), lens = stage.querySelector('.nhx-res__lens');
    let actual = fs[0];
    const mover = e => {
      const r = rel(e, stage);
      stage.classList.add('is-lupa');
      lens.style.left = (r.x * 100) + '%'; lens.style.top = (r.y * 100) + '%';
      lens.style.backgroundImage = 'url("' + actual.src + '")';
      lens.style.backgroundPosition = (r.x * 100) + '% ' + (r.y * 100) + '%';
    };
    drag(stage, { move: mover, hover: fino ? mover : null, end: () => { if (!fino) stage.classList.remove('is-lupa'); } });
    stage.addEventListener('pointerleave', () => stage.classList.remove('is-lupa'));
    root.querySelectorAll('[data-i]').forEach(b => b.addEventListener('click', () => {
      const f = fs[+b.dataset.i]; actual = f;
      img.classList.add('is-swap');
      precargar(f.src).then(() => { img.src = f.src; img.classList.remove('is-swap'); });
      root.querySelectorAll('[data-i]').forEach(x => x.setAttribute('aria-selected', x === b));
    }));
    return true;
  }

  /* ---------------- arranque ---------------- */
  function iniciar(sec) {
    if (sec.dataset.nhxListo) return;
    sec.dataset.nhxListo = '1';
    const root = sec.querySelector('[data-nhx-root]');
    const tipo = sec.dataset.nhxTipo || 'reserva';
    const fuente = sec.dataset.nhxFuente || 'experiencia';
    let dato = null;
    const s = sec.querySelector('[data-nhx-dato]');
    try { dato = s ? JSON.parse(s.textContent) : null; } catch (e) { dato = null; }
    dato = parseJSON(dato);
    const idx = parseInt(sec.dataset.nhxIndice || '0', 10) || 0;
    if (Array.isArray(dato) && fuente !== 'puntos' && fuente !== 'pasos') dato = dato[idx] || null;
    if (dato && typeof dato === 'object' && !Array.isArray(dato) && dato.datos && typeof dato.datos === 'object') dato = Object.assign({}, dato.datos, dato);
    const ctx = { sec, root, tipo, fuente, producto, foto, fotoVariante, fotoAmbiente, fotosEstudio, medidas, num, fmt, clamp, lerp, el, esc, drag, rel, alVer,
      precargar, animar, suave, colorHex, opcionColor, seleccionar, alCambiarVariante, pista, imgTag, reduce, fino, puntosDescripcion,
      titulo(t, lead) { // el texto del JSON manda sobre el de la sección
        const h = sec.querySelector('[data-nhx-titulo]'), l = sec.querySelector('[data-nhx-lead]');
        if (t && h) h.innerHTML = esc(t).replace(/\[(.+?)\]/g, '<em>$1</em>');
        if (lead && l) { l.textContent = lead; l.hidden = false; }
      },
      oscuro(si) { sec.classList.toggle('nhx--noche', !!si); }
    };
    let ok = false;
    if (dato && typeof dato === 'object' && tipos[tipo]) {
      try {
        if (dato.titulo || dato.texto) ctx.titulo(dato.titulo, dato.texto);
        ok = tipos[tipo](root, dato, ctx) !== false;
      } catch (e) { ok = false; if (window.console) console.error('[nhx] ' + tipo, e); root.innerHTML = ''; }
    }
    if (!ok) {
      sec.classList.add('nhx--reserva');
      if (fuente === 'experiencia' || fuente === 'puntos') ok = reserva(root, sec, fuente);
      if (ok && fuente === 'experiencia') ctx.titulo(sec.dataset.nhxReservaTitulo || 'Míralo [de cerca]', null);
    }
    if (!ok) { sec.hidden = true; return; }
    sec.classList.add('nhx--listo');
    // aparecer al bajar dentro de la experiencia
    sec.querySelectorAll('.nhx-in').forEach(x => alVer(x, () => x.classList.add('in'), 0.2));
  }
  // Los scripts "defer" corren antes de DOMContentLoaded: se espera a ese evento para que cada exp-<tipo>.js ya se
  // haya registrado. Si un tipo llega tarde (p. ej. en el editor), se arranca al registrarse.
  let domListo = document.readyState === 'complete';
  function todo() { domListo = true; document.querySelectorAll('[data-nhx]').forEach(iniciar); }
  NHX.registrar = function (tipo, fn) {
    tipos[tipo] = fn;
    if (domListo) document.querySelectorAll('[data-nhx][data-nhx-tipo="' + tipo + '"]:not([data-nhx-listo])').forEach(iniciar);
  };
  if (domListo) setTimeout(todo, 0); else document.addEventListener('DOMContentLoaded', todo);
  // en el editor de temas las secciones se recargan solas
  document.addEventListener('shopify:section:load', e => { const s = e.target.querySelector('[data-nhx]'); if (s) iniciar(s); });
})();
